import React from 'react';
import { useTranslation } from 'react-i18next';
import LaRocaLogo from '../../assets/images/laroca_village_logo.png';
import LaValleeLogo from '../../assets/images/lavalle_village_logo.png';
import BicesterLogo from '../../assets/images/bicester_village_logo.png';
import FidenzaLogo from '../../assets/images/fidenza_village_logo.png';
import ModernShopList from '../../components/common/ModernShopList';
import { CommonVillageNameProps } from '../../interfaces/components';
import { villagePrefixes } from '../../utils/helper';

const Womenswear = ({ active, setActive, villageName }: CommonVillageNameProps) => {
  const { t } = useTranslation();
  const prefix = villagePrefixes[villageName] ?? 'lr';

  return (
    <>
      <ModernShopList
        active={active}
        setActive={setActive}
        category="Boutiques"
        subcategory={t('womenswear')}
        list={t(`${prefix}_womenswear_brands`)}
        headerImg={
          villageName === 'la_vallee'
            ? LaValleeLogo
            : villageName === 'bicester'
            ? BicesterLogo
            : villageName === 'fidenza'
            ? FidenzaLogo
            : LaRocaLogo
        }
      />
    </>
  );
};

export default Womenswear;
